import { ComponentType } from 'react';
import { IdentityTypeCode } from '@verifime/utils';
import PersonIcon from '@mui/icons-material/Person';
import ApartmentIcon from '@mui/icons-material/Apartment';
import HandshakeIcon from '@mui/icons-material/Handshake';
import GroupsIcon from '@mui/icons-material/Groups';
import SavingsIcon from '@mui/icons-material/Savings';
import WorkIcon from '@mui/icons-material/Work';
import BusinessIcon from '@mui/icons-material/Business';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

export type TEntityPillKind = IdentityTypeCode | 'Business_Trust';

/**
 * UX-authoritative labels for each entity kind.
 * All uppercase per design specification.
 */
export const ENTITY_PILL_LABEL_MAP: Record<TEntityPillKind, string> = {
  [IdentityTypeCode.Individual_Domestic]: 'INDIVIDUAL',
  Business_Trust: 'BUSINESS / TRUST',
  [IdentityTypeCode.SMSF]: 'SELF MANAGED SUPER FUND',
  [IdentityTypeCode.Sole_Trader]: 'SOLE TRADER',
  [IdentityTypeCode.Partnership]: 'PARTNERSHIP',
  [IdentityTypeCode.Private_Company]: 'PRIVATE COMPANY',
  [IdentityTypeCode.Public_Company]: 'PUBLIC COMPANY',
  [IdentityTypeCode.Trust_Regulated]: 'REGULATED TRUST',
  [IdentityTypeCode.Trust_Unregulated]: 'UNREGULATED TRUST',
};

/**
 * MUI icon component for each entity kind.
 *
 * Icon picks:
 *   Individual_Domestic  -> PersonIcon      (individual person)
 *   Business_Trust       -> BusinessIcon    (combined business + trust sentinel)
 *   SMSF                 -> SavingsIcon     (superannuation / savings fund)
 *   Sole_Trader          -> WorkIcon        (sole individual operating a business)
 *   Partnership          -> HandshakeIcon   (two parties in agreement)
 *   Private_Company      -> ApartmentIcon   (private building / closed company)
 *   Public_Company       -> AccountBalanceIcon (public institution)
 *   Trust_Regulated      -> GroupsIcon      (regulated group entity)
 *   Trust_Unregulated    -> GroupsIcon      (unregulated group entity, same visual category)
 */
export const ENTITY_PILL_ICON_MAP: Record<TEntityPillKind, ComponentType> = {
  [IdentityTypeCode.Individual_Domestic]: PersonIcon,
  Business_Trust: BusinessIcon,
  [IdentityTypeCode.SMSF]: SavingsIcon,
  [IdentityTypeCode.Sole_Trader]: WorkIcon,
  [IdentityTypeCode.Partnership]: HandshakeIcon,
  [IdentityTypeCode.Private_Company]: ApartmentIcon,
  [IdentityTypeCode.Public_Company]: AccountBalanceIcon,
  [IdentityTypeCode.Trust_Regulated]: GroupsIcon,
  [IdentityTypeCode.Trust_Unregulated]: GroupsIcon,
};
